export default __webpack_public_path__ + "static/media/button.7116d1b8.png";